// extracted by mini-css-extract-plugin
export default {"cabecalho":"Cabecalho_cabecalho__HMrxR","container":"Cabecalho_container__-lH2z","usuario":"Cabecalho_usuario__Qn7bH"};